import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home as HomeIcon } from 'lucide-react';
import { getToolByPath, localizedToolTitle } from '@/lib/toolCategories';

export default function Breadcrumb() {
  const location = useLocation();
  const { t } = useTranslation();
  const tool = getToolByPath(location.pathname, location.search);
  if (!tool) return null;
  const toolName = localizedToolTitle(t, tool);
  return (
    <nav className="topnav-breadcrumb" aria-label="Breadcrumb">
      <a href="/">
        <HomeIcon className="home-icon" aria-hidden="true" />
        {t('common:breadcrumb.home') || 'Home'}
      </a>
      <span className="sep" aria-hidden="true">›</span>
      <span className="current">{toolName}</span>
    </nav>
  );
}
